import { c as _c } from "react/compiler-runtime";
import { useAuth } from '@clerk/nextjs';
import { ApiError } from '@lib/api/api-response';
import { trackInsightDocumentReprocessClicked } from '@lib/observability/insights/track-insight-reprocess.client';
import { useQueryClient } from '@lib/query/client';
import { useAuthedMutation } from '@lib/query/use-authed-query';
import { toast } from 'sonner';
import { invalidateInsightReprocessQueries } from './invalidate-insight-reprocess-queries';
interface ReprocessParams {
  documentId: string;
}
export function useReprocessInsightDocument() {
  const $ = _c(7);
  const queryClient = useQueryClient();
  const {
    orgId
  } = useAuth();
  let t0;
  if ($[0] !== orgId) {
    t0 = async t1 => {
      const {
        documentId
      } = t1;
      trackInsightDocumentReprocessClicked({
        documentId,
        orgId: orgId ?? null
      });
      const response = await fetch(`/api/protected/insights/documents/${documentId}/reprocess`, {
        method: "POST"
      });
      if (!response.ok) {
        throw new ApiError("Failed to reprocess document", response.status);
      }
    };
    $[0] = orgId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== queryClient) {
    t1 = () => {
      invalidateInsightReprocessQueries(queryClient);
    };
    $[2] = queryClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      mutationFn: t0,
      onSuccess: t1,
      onError: _temp
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useAuthedMutation(t2);
}
function _temp() {
  toast.error("Could not retry this document");
}